/**
 * 节点布局容器组件
 */
import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { useNodeOperations } from '../providers/NodeOperationsProvider';
import './NodeLayout.css';

export const NodeLayout = memo(({ 
  id,
  type,
  title, 
  children,
  showInputHandle = true,
  showOutputHandle = true,
  inputHandleId,
  inputHandleLabel = '文本',
  isValidConnection,
  onInputHandleClick,
}) => {
  const { duplicateNode } = useNodeOperations();

  const handleDuplicate = (e) => {
    e.stopPropagation(); // 防止触发节点的其他事件
    duplicateNode(id);
  };

  return (
    <div className="NodeLayout-container">
      {/* 复制按钮 */}
      <button 
        className="NodeLayout-duplicate-button"
        onClick={handleDuplicate}
        title="复制节点"
      >
        <i className="bi bi-copy"></i>
      </button>

      {/* 输入 Handle */}
      {showInputHandle && (
        <Handle
          type="target"
          position={Position.Left}
          id={inputHandleId}
          className="NodeLayout-handle NodeLayout-handle-input"
          isValidConnection={isValidConnection}
        >
          <div 
            className={`NodeLayout-handle-label ${onInputHandleClick ? 'NodeLayout-handle-label-clickable' : ''}`}
            onClick={onInputHandleClick}
            title={onInputHandleClick ? '点击自动创建文本输入节点' : undefined}
          >
            {inputHandleLabel}
          </div>
        </Handle>
      )}

      {/* 标题 */}
      <div className="NodeLayout-title">
        {title}
      </div>

      {/* 内容 */}
      <div className="NodeLayout-content">{children}</div>

      {/* 输出 Handle */}
      {showOutputHandle && (
        <Handle
          type="source"
          position={Position.Right}
          id="output"
          className="NodeLayout-handle NodeLayout-handle-output"
        />
      )}
    </div>
  );
});

NodeLayout.displayName = 'NodeLayout';

